<template>
  <div class="news-letter-list">
    <data-table :service="service"
                :entity="entity"
                :columns="columns"
                :disable-permission-checks="true"
                ref="table">
      <template v-slot:candidates="{row}">
        <status-badge :status="row.candidates ? 'active': 'inactive'"></status-badge>
      </template>
      <template v-slot:clients="{row}">
        <status-badge :status="row.clients ? 'active': 'inactive'"></status-badge>
      </template>
    </data-table>
  </div>
</template>
<script>
  import Badge from 'src/components/Badge'
  import NewsLetterService from 'src/services/NewsLetterService';
  import entities from 'src/config/entities';

  export default {
    name: 'news-letter-list',
    components: {
      Badge
    },
    data() {
      return {
        service: NewsLetterService,
        entity: entities.NEWSLETTER
      }
    },
    computed: {
      columns() {
        return [
          {
            prop: "name",
            label: this.$t('generic.name'),
            minWidth: "200px",
          },
          {
            prop: "description",
            label: this.$t('generic.description'),
            minWidth: "220px",
          },
          {
            prop: "opt_in_message",
            label: this.$t('newsletter.form.opt_in_message'),
            minWidth: "220px",
          },
          {
            prop: "candidates",
            label: this.$t('generic.candidates'),
            minWidth: "80px",
          },
          {
            prop: "clients",
            label: this.$t('generic.clients'),
            minWidth: "80px",
          },
        ]
      }
    }
  }
</script>
<style lang="scss" scoped>
  .post-image {
    min-width: 144px;
  }
  .segments__container {
    overflow-x: auto;
    display: flex;
  }
</style>
